import PromptNode from './PromptNode';
import TextGenNode from './TextGenNode';
import VisualNode from './VisualNode';
import WorksheetNode from './WorksheetNode';
import AudioNode from './AudioNode';
import UploadNode from './UploadNode';
import InputNode from './InputNode';
import ApiNode from './ApiNode';
import OfflineLLMNode from './OfflineLLMNode';
import MCQNode from './MCQNode';
import ShortAnswerNode from './ShortAnswerNode';
import ImageAnalysisNode from './ImageAnalysisNode';

export const nodeTypes = {
  prompt: PromptNode,
  textGen: TextGenNode,
  visual: VisualNode,
  worksheet: WorksheetNode,
  audio: AudioNode,
  upload: UploadNode,
  input: InputNode,
  api: ApiNode,
  offlineLLM: OfflineLLMNode,
  mcq: MCQNode,
  shortAnswer: ShortAnswerNode,
  imageAnalysis: ImageAnalysisNode,
};